import { format, parse } from 'date-fns'

export const formatarData = (date,padrao) => date ? format(new Date(date), padrao) : null;

export const toDate = date => date ? format(new Date(date), 'dd/MM/yyyy') : null;

export const toDateTime = date => date ? format(new Date(date), "dd/MM/yyyy HH:mm:ss") : null;

export const toDateTimeForCompare = date => date ? new Date(date) : null;

export const parseDate = date => date ? parse(date, "dd/MM/yyyy", new Date()) : null;

export const parseDateTime = date => date ? parse(date, "dd/MM/yyyy HH:mm:ss", new Date()) : null;
